import { createMachine, assign, fromPromise } from "xstate";
import actions from "./actions";
import guards from "./guards";
import context from "./context";
import data from "../animData";

let startTime;
let def = {
  initial: "loading",

  context,

  on: {
    "*": {
      actions: "setPreviousState",
    },
    TOGGLE_SIDEBAR: {
      actions: "toggleSidebar",
    },
    TOGGLE_MENU: {
      actions: "toggleMenu",
    },
    SKIP_TO_PRIME: {
      target: ".primeBottle1",
    },
    SKIP_TO_DROP: {
      target: ".dropSize1",
      actions: {
        type: "setOverrideTitle",
        params: { title: "DropSize" },
      },
    },
    CLEAR_OVERRIDE_TITLE: {
      actions: {
        type: "setOverrideTitle",
        params: { title: null },
      },
    },
    SKIP_TO_BLINK: {
      target: ".blinkReflex1",
      actions: {
        type: "setOverrideTitle",
        params: { title: "BlinkReflex" },
      },
    },

    SKIP_TO_WHAT_PATIENTS: {
      target: ".whatPatients",
    },
    SKIP_TO_START: {
      // actions: (_) => alert(1),
      target: ".place",
    },
    SHOW_SECTION_TITLE: {
      actions: "showSectionTitle",
    },
    HIDE_SECTION_TITLE: {
      actions: "hideSectionTitle",
    },
    STARTED: {
      actions: "setStarted",
    },
  },

  states: {
    loading: {
      entry: (_) => (startTime = performance.now()),
      on: {
        LOADED_GLTF: [
          {
            target: "start",
            guard: ({ context, event }) => {
              return context.hdrLoaded;
            },
          },
          {
            actions: assign({
              gltfLoaded: true,
            }),
          },
        ],
        LOADED_ENV: [
          {
            target: "start",
            guard: ({ context, event }) => {
              return context.gltfLoaded;
            },
          },
          {
            actions: assign({
              hdrLoaded: true,
            }),
          },
        ],
      },
      // TEMP
      // after: {
      //   1000: {
      //     target: "start",
      //   },
      // },
    },
    start: {
      entry: (_) => {
        window.gaEvent({ event: "app_ready" });
      },
      on: {
        START: {
          target: "disclaimer",
        },
      },
    },
    disclaimer: {
      entry: (_) => {
        window.gaEvent({ event: "experience_button_start" });
      },
      on: {
        CONTINUE: {
          target: "place",
          actions: "startAR",
        },
      },
    },
    place: {
      entry: ["resetAR", (_) => window.gaEvent({ event: "app_launch" })],
      on: {
        PLACE: {
          target: "readyForStart",
          actions: [
            "placeAR",
            (_) => window.gaEvent({ event: "experience_placed" }),
          ],
        },
      },
    },
    readyForStart: {
      entry: [
        assign({
          hasPlaced: true,
        }),
      ],
      on: {
        START_EXPERIENCE: {
          target: "primeBottle1Animation",
        },
      },
    },
    whatPatients: {
      entry: [
        "showSectionTitle",
        (_) => window.gaEvent({ event: "experience_complete" }),
      ],
    },
    primeBottle1: {
      entry: [
        "showSectionTitle",
        {
          type: "setOverrideTitle",
          params: { title: null },
        },
      ],
      on: {
        CONTINUE: {
          target: "primeBottle1Animation",
        },
      },
    },
    primeBottle1Animation: {
      on: {
        PRIMEBOTTLE1ANIMATION_DONE: {
          target: "primeBottle2",
        },
      },
    },
    primeBottle2: {
      entry: "showSectionTitle",
      on: {
        CONTINUE: {
          target: "primeBottle2Animation",
        },
      },
    },
    primeBottle2Animation: {
      on: {
        PRIMEBOTTLE2ANIMATION_DONE: {
          target: "primeBottle3",
        },
      },
    },
    primeBottle3: {
      entry: "showSectionTitle",
      on: {
        CONTINUE: {
          target: "primeBottle3Animation",
        },
      },
    },
    primeBottle3Animation: {
      on: {
        PRIMEBOTTLE3ANIMATION_DONE: {
          target: "dropSize1",
          // target: "primeBottleWait",
        },
      },
    },
    // primeBottleWait: {
    //   // after: {
    //   //   50: {
    //   //     target: "dropSize1",
    //   //   },
    //   // },
    //   entry: "showSectionTitle",
    //   on: {
    //     CONTINUE: {
    //       target: "dropSize1Animation",
    //     },
    //   },
    // },
    dropSize1: {
      entry: "showSectionTitle",

      on: {
        CONTINUE: {
          target: "dropSize1Animation",
        },
      },
    },
    dropSize1Animation: {
      after: {
        1200: {
          actions: {
            type: "setOverrideTitle",
            params: { title: "DropSize" },
          },
        },
      },
      exit: [
        {
          type: "setOverrideTitle",
          params: { title: null },
        },
      ],
      on: {
        DROPSIZE1ANIMATION_DONE: {
          target: "blinkReflex1",
        },
      },
    },
    blinkReflex1: {
      entry: "showSectionTitle",
      on: {
        CONTINUE: {
          target: "blinkReflex1Animation",
        },
      },
    },
    blinkReflex1Animation: {
      after: {
        1200: {
          actions: {
            type: "setOverrideTitle",
            params: { title: "BlinkReflex" },
          },
        },
      },
      exit: [
        {
          type: "setOverrideTitle",
          params: { title: null },
        },
      ],
      on: {
        BLINKREFLEX1ANIMATION_DONE: {
          target: "blinkReflex3",
        },
      },
    },
    blinkReflex3: {
      entry: "showSectionTitle",
      on: {
        CONTINUE: {
          target: "blinkReflex3Animation",
        },
      },
    },
    blinkReflex3Animation: {
      on: {
        BLINKREFLEX3ANIMATION_DONE: {
          target: "whatPatients",
        },
        HIDE_DISCLAIMER: {
          actions: "hideDisclaimer",
        },
      },
      entry: "showDisclaimer",
    },
  },
};

const keys = Object.keys(data);
// const { states } = def;
// const states = {}
// for (let i = 0; i < keys.length; i++) {
//   const key = keys[i];

//   states[key] = {
//     entry: "showSectionTitle",
//     on: {
//       CONTINUE: {
//         target: key + "Animation",
//       },
//     },
//   };
//   states[key + "Animation"] = {
//     on: {
//       [key.toUpperCase() + "ANIMATION_DONE"]: {
//         target: keys[i + 1] || "whatPatients",
//       },
//     },
//   };
// }

export const stateMachine = createMachine(def, {
  actions: {
    ...actions,
  },
  guards: { ...guards },
});

window.sm = stateMachine;
